<template>
  <div class="other-news  wc">
      <div class="container-landing ttl-wrapper">
          <div class="ttl">
              <h2 class="f-21">{{ $fn.tr('სხვა ამბები') }}</h2>
          </div>
          <div class="all-news">
              <svg xmlns="http://www.w3.org/2000/svg" width="26.204" height="19.069" viewBox="0 0 26.204 19.069">
  <g id="Group_104" data-name="Group 104" transform="translate(25.293 -3.205)">
    <g id="menu" transform="translate(-24.753 3.741)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M11.651,15.232a47.863,47.863,0,0,1,6.08-4.246c.587-.348,1.189-.681,1.808-.97-.9-.037-1.811,0-2.716.037-.962.04-1.912.077-2.82.032-3.919-.212-7.8-.931-11.731-.857C.919,9.251-1.3,7.224.991,7.181c4.459-.083,8.831.8,13.278.9.737.014,1.49,0,2.252-.021a24.421,24.421,0,0,1,5.028.239c-2.2-2.309-4.712-4.311-6.6-6.9-.568-.776-.117-2.053.66-.986,2.278,3.126,5.475,5.4,7.917,8.384a1.282,1.282,0,0,1,.2.348,1.021,1.021,0,0,1,.322.781c0,.034,0,.067,0,.1-.02.588-.86.709-1.7.514a11.6,11.6,0,0,0-4.386,2.012,53.818,53.818,0,0,0-5.009,3.574,1.152,1.152,0,0,1-.735.245C11.529,16.362,10.9,15.848,11.651,15.232Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 1.677)" fill="#101820" stroke="#101820" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>

<router-link :to="getNewsLink[0].full_url" class="f-21">{{$fn.tr('ყველა ამბავი')}}</router-link>
          </div>
      </div>
      <div class="container-landing other-news-wrapper">
              <router-link :to="$store.getters['main/getSingleUrl'](news)" class="news-list-box" v-for="(news, index) in avoidSameNews" :key="index">
            <div class="news-list-box-img-wrapper">
                 <img :src="news.cover[0].url"  :alt="get_alt(news)" v-if="news.cover[0]"> 
            </div>
          
           <div class="news-list-box-text-block">
               <span class="f-21">{{date(news.date)}}</span>
              <span class="f-21 bold news-desc">{{news.title}}</span>
               <a href="#" class="read-more">
                   <svg xmlns="http://www.w3.org/2000/svg" width="23.088" height="17.048" viewBox="0 0 23.088 17.048">
  <g id="Group_375" data-name="Group 375" transform="translate(25.3 -3.214)">
    <g id="menu" transform="translate(-24.753 3.741)">
      <g id="Group_103" data-name="Group 103" transform="translate(0 0)">
        <path id="Union_6" data-name="Union 6" d="M10.186,13.528a42.026,42.026,0,0,1,5.327-3.78c.514-.31,1.042-.606,1.584-.864-.785-.032-1.585,0-2.378.035-.842.037-1.674.07-2.469.031C8.82,8.766,5.424,8.13,1.98,8.2.8,8.221-1.146,6.422.861,6.382c3.9-.078,7.731.7,11.624.784.645.011,1.3,0,1.972-.021a21.057,21.057,0,0,1,4.4.208c-1.921-2.05-4.121-3.827-5.775-6.129-.5-.689-.1-1.825.578-.877,1.991,2.776,4.788,4.795,6.924,7.444a1.141,1.141,0,0,1,.178.309.913.913,0,0,1,.281.694c0,.031,0,.059,0,.086-.018.523-.753.631-1.488.459a10.106,10.106,0,0,0-3.842,1.793,47.276,47.276,0,0,0-4.389,3.181,1,1,0,0,1-.644.218C10.078,14.532,9.532,14.076,10.186,13.528Z" transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 1.491)" fill="#101820" stroke="#101820" stroke-width="1"/>
      </g>
    </g>
  </g>
</svg>
<span class="f-16">{{ $fn.tr('ვრცლად') }}</span>
               </a>
           </div>
      </router-link>
      </div>
  </div>
</template>

<script>
import moment from "../../helpers/moment";
export default {
  props: ['contentData'],
  mounted(){
    
  },
  watch: {
    '$route'(to, from) {
    
    
  }
  },
computed: {
    
    getNewsLink(){
      let menu = this.$store.state.main.indx.menus;
       return menu.filter(m => m.url_slug === 'news')
    },
    avoidSameNews(){
      let news = null;
      if(this.$store.state.main.current_content_request_status === 'done'){
        news = _.get(this.contentData, 'data.list');
            news = news.filter(ne => ne.id !== this.$store.state.main.current_content.primary.data.list[0].id);
            news = news.splice(0, 2);
            return news;
      } 
    }
},
methods: {
     get_alt(content){
      if(content.seo_title_ge && this.$store.state.main.locale == 'ge'){
        return content.seo_title_ge;
      } else if (content.seo_title_ge && this.$store.state.main.locale == 'en'){
        return content.seo_title_en;

      } else {
          return ' ';
      }
    },
    date(dateParam){
      if(this.$route.name === 'ge') moment.locale('ka');
              
         if(this.$route.name == 'ge'){
         
           return  moment(dateParam).locale('ka').format("DD MMM YYYY");
         } else if(this.$route.name == 'en'){
         
         return  moment(dateParam).locale('en').format("DD MMM YYYY");
        }
    },
}
}
</script>

<style lang="scss" scoped>

</style>